import { useTranslation } from '@utils/i18n/i18n.consumers';

import './infographic-template.styl';

function InfographicTemplate({ selectedPart }) {
  const { t } = useTranslation()
  return (
    <div className="infographic-template">
      <h3>{t(`${selectedPart.title}`)}</h3>
      {selectedPart.description && <p>{t(`${selectedPart.description}`)}</p>}
      <div className="infographic-template__image">
        <img src={selectedPart.image} alt={t(`${selectedPart.title}`)} />
        {selectedPart.imageCopyright && (
          <span className="infographic-template__image__copyright">
            {selectedPart.imageCopyright}
          </span>
        )}
      </div>
      {selectedPart.caption && <p className="infographic-template__caption">{t(`${selectedPart.caption}`)}</p>}
    </div>
  );
} 

export default InfographicTemplate;